'use client';

import HeadlineField from '@/components/customFields/HeadlineField';
import { HeadlineTag } from '@/components/customFields/types';
import { Divider } from '@/components/divider';
import NestedBlocks from '@/components/nestedBlocks/NestedBlocks';
import { RichText } from '@/components/richText/RichText';
import type { ComponentLibraryChapterStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';

import classes from '../guidePage/guidePage.module.scss';

export default function GuidePage({ blok }: { blok: ComponentLibraryChapterStoryblok }) {
  return (
    <>
      <Divider aria-hidden={true} />
      <div id={blok._uid} className={classes.section} {...storyblokEditable(blok)}>
        <HeadlineField className={classes.section__title} tag={HeadlineTag.H2} style={HeadlineTag.H4}>
          {blok.title}
        </HeadlineField>
        <RichText className={classes.section__description} text={blok.description}></RichText>

        <div className={classes.section__components}>
          <NestedBlocks blocks={blok.components} />
        </div>
      </div>
    </>
  );
}
